<script lang="ts">
  import ModalTemplate from '../shared/ModalTemplate.svelte'
  import {t} from '../../src/i18n'
  import {modal} from '../../src/stores/modal'

  export let title: string
  export let onConfirm: () => Promise<any>
  let confirming = false

  function onCancel(e: Event) {
    e.preventDefault()
    modal.close()
  }

  async function onConfirmAndClose(e: Event) {
    e.preventDefault()
    try {
      confirming = true
      await onConfirm()
      modal.close()
    } finally {
      confirming = false
    }
  }
</script>

<ModalTemplate size="tiny">
  <div class="modal-content">
    <h2 class="tc">{title}</h2>
    <div class="buttons">
      <button class="ui button" type="button" onclick={onCancel}>{t.general.cancel}</button>
      <button class="ui button black" type="button" disabled={confirming} onclick={onConfirmAndClose}>{t.general.confirm}</button>
    </div>
  </div>
</ModalTemplate>

<style>
  .buttons {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }

  .buttons .button {
    flex: 1;
  }
</style>